jQuery(document).ready(function($) {
  const plotList = document.getElementById('plot-list')
  var loadMoreEl = document.querySelector('.load-more')
  var loadMoreWrapper = document.querySelector('.load-more-wrapper')
  var mixer
  var homeOfTheWeek = 0
  var cardLimit = 8
  var incrementAmount = cardLimit
  if ($('.single-harron_developments #plot-list').length > 0) {
    // Now we're on the development page, let's check to make sure there's a home of the week set
    let featuredPlots = $('article.featured__plot')
    if (featuredPlots.length > 0) {
      homeOfTheWeek = 1
    }
  }
  var currentLimit = cardLimit + homeOfTheWeek

  if (plotList) {
    mixer = mixitup(plotList, {
      pagination: {
        limit: currentLimit,
      },
      callbacks: {
        onMixEnd: handleMixEnd,
      },
      load: {
        sort: 'plot-hotw:asc plot-status:asc', 
      },
    })
    var mixerState = mixer.getState()
    handleMixEnd(mixerState)
    function handleMixEnd(state) {
      if (Array.isArray(state.hide) && state.hide.length) {
        if (loadMoreEl.disabled) {
          // Enable button
          loadMoreEl.disabled = false
        }
      } else {
        // Disable button
        loadMoreEl.disabled = true
        loadMoreWrapper.style.display = 'none'
      }
    }
    function handleLoadMoreClick() {
      // On each click of the load more button, we increment
      // the current limit by a defined amount
      currentLimit += incrementAmount
      mixer.paginate({limit: currentLimit})
    }
    loadMoreEl.addEventListener('click', handleLoadMoreClick)
  }
})
